import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './state/auth';
import { LoginPage } from './pages/LoginPage';
import { EmployeeLayout } from './pages/employee/EmployeeLayout';
import { AdminLayout } from './pages/admin/AdminLayout';

function Loading() {
  return <div className="container"><div className="card">Caricamento…</div></div>;
}

function RequireAuth({ children, role }: { children: React.ReactNode; role?: 'ADMIN'|'EMPLOYEE' }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === 'ADMIN' ? '/admin' : '/'} replace />;
  return <>{children}</>;
}

export function App() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === 'ADMIN' ? '/admin' : '/'} replace /> : <LoginPage />} />
      <Route path="/*" element={<RequireAuth role="EMPLOYEE"><EmployeeLayout /></RequireAuth>} />
      <Route path="/admin/*" element={<RequireAuth role="ADMIN"><AdminLayout /></RequireAuth>} />
    </Routes>
  );
}
